export const obj = {
  // 財務管理
  // menu_financial: {
  //   MenuCode: "menu_financial",
  //   MenuName: "financialManagement"
  // },
  // 住宿費
  menu_hotel_expense: {
    MenuCode: "menu_hotel_expense",
    MenuName: "hotelExpense",
    Url: "/hotelExpense"
  },
  // menu_dormitory 宿舍管理
  menu_dormitory: {
    MenuCode: "menu_dormitory",
    MenuName: "dormitoryManagement"
  },
  // menu_dormitory_list 宿舍列表
  menu_dormitory_list: {
    MenuCode: "menu_dormitory_list",
    MenuName: "dormitoryList",
    Url: "/dormitoryList"
  },
  // menu_pre_dis_new_stu 新生預分配
  menu_pre_dis_new_stu: {
    MenuCode: "menu_pre_dis_new_stu",
    MenuName: "preDistributionOfNewStudents",
    Url: "/preDistributionOfNewStudents"
  },
  // menu_pre_dis_old_stu 舊生預分配
  menu_pre_dis_old_stu: {
    MenuCode: "menu_pre_dis_old_stu",
    MenuName: "preDistributionOfOldStudents",
    Url: "/preDistributionOfOldStudents"
  },
  // menu_dormitory_diagram 宿舍示意圖
  menu_dormitory_diagram: {
    MenuCode: "menu_dormitory_diagram",
    MenuName: "dormitoryDiagram",
    Url: "/dormitoryDiagram"
  },
  // menu_check_out_approval 退宿審批
  menu_check_out_approval: {
    MenuCode: "menu_check_out_approval",
    MenuName: "checkOutApproval",
    Url: "/checkOutApproval"
  },
  // menu_report_center 報表中心
  menu_report_center: {
    MenuCode: "menu_report_center",
    MenuName: "reportCenter"
  },
  // menu_report_check_in 入住查詢
  menu_report_check_in: {
    MenuCode: "menu_report_check_in",
    MenuName: "checkIn",
    Url: "/reportCheckIn"
  },
  // menu_pickup_service_report 接載服務時間表
  menu_pickup_service_report: {
    MenuCode: "menu_pickup_service_report",
    MenuName: "pickup",
    Url: "/reportPickup"
  },
  // menu_report_check_out
  menu_report_check_out: {
    MenuCode: "menu_report_check_out",
    MenuName: "checkOut",
    Url: "/reportCheckOut"
  },
  // menu_report_bed_change
  menu_report_bed_change: {
    MenuCode: "menu_report_bed_change",
    MenuName: "bedChange",
    Url: "/reportBedChange"
  },
  // menu_report_bed
  menu_report_bed: {
    MenuCode: "menu_report_bed",
    MenuName: "bed",
    Url: "/reportBed"
  },
  // menu_report_arrival
  // menu_report_arrival: {
  //   MenuCode: "menu_report_arrival",
  //   MenuName: "arrival",
  //   Url: "/reportArrival"
  // },
  // menu_report_departure
  // menu_report_departure: {
  //   MenuCode: "menu_report_departure",
  //   MenuName: "departure",
  //   Url: "/reportDeparture"
  // },
  // menu_report_guest
  menu_report_guest: {
    MenuCode: "menu_report_guest",
    MenuName: "guestReport",
    Url: "/reportGuest"
  },
  menu_cashier_report: {
    MenuCode: "menu_report_cashier",
    MenuName: "cashierReport",
    Url: "/reportCashier"
  },
  menu_report_bedtag_balance: {
    MenuCode: "menu_report_bedtag_balance",
    MenuName: "bedtagBalance",
    Url: "/reportbedtagBalance"
  },
  // menu_report_payment
  menu_report_payment: {
    MenuCode: "menu_report_payment",
    MenuName: "payment",
    Url: "/reportPayment"
  },
  // menu_overnight_management 夜归不归
  menu_overnight_management: {
    MenuCode: "menu_overnight_management",
    MenuName: "overnight",
    Url: "/dormitoryOvernight"
  },
  // menu_backstage_index 首頁
  menu_backstage_index: {
    MenuCode: "menu_index",
    MenuName: "home",
    Url: "/backstage"
  },
  // menu_system 系統管理
  menu_system: {
    MenuCode: "menu_system_management",
    MenuName: "systemManagement"
  },
  // menu_params_config 參數配置
  menu_params_config: {
    MenuCode: "menu_params_config",
    MenuName: "parameterConfiguration",
    Url: "/parameterConfiguration"
  },
  // menu_role 角色管理
  menu_role: {
    MenuCode: "menu_role_management",
    MenuName: "roleManagement",
    Url: "/roleManagement"
  },
  // menu_dict 字典管理
  menu_dict: {
    MenuCode: "menu_dictionary_management",
    MenuName: "dictionaryManagement",
    Url: "/dictionaryManagement"
  },
  // 床位标签管理
  bed_tags_manager: {
    MenuCode: "menu_dictionary_management",
    MenuName: "BedTagsManagement",
    Url: "/BedTagsManagement"
  },
  // menu_user 用戶管理
  menu_user: {
    MenuCode: "menu_user_management",
    MenuName: "userManagement",
    Url: "/userManagement"
  },
  // menu_template 模板管理
  menu_template: {
    MenuCode: "menu_template_management",
    MenuName: "templateManagement",
    Url: "/templateManagement"
  },
  // menu_room 房間管理
  menu_room: {
    MenuCode: "menu_room_management",
    MenuName: "roomManagement",
    Url: "/roomManagement"
  },
  // 訪客住宿
  menu_visitor: {
    MenuCode: "menu_guest",
    MenuName: "guest"
  },
  // 訪客住宿預約
  menu_visitor_booking: {
    MenuCode: "menu_guest_appointment",
    MenuName: "guestAppointment",
    Url: "/appointment"
  },
  // 訪客住宿預約列表
  menu_visitor_booking_management: {
    MenuCode: "menu_guest_appointment_list",
    MenuName: "guestAppointmentList",
    Url: "/appointmentList"
  },
  menu_document: {
    MenuCode: "menu_document",
    MenuName: "documentManagement"
  },
  menu_document_student: {
    MenuCode: "menu_document_student",
    MenuName: "documentStudent",
    Url: "/documentStudent"
  },
  // menu_hostel_apply_list 住宿申請情況
  menu_hostel_apply_list: {
    MenuCode: "menu_hostel_apply_list",
    MenuName: "hostelApplyList",
    Url: "/hostelApplyList"
  },
  //退宿歷史記錄
  menu_hostel_checkout_history: {
    MenuCode: "menu_hostel_checkout_history",
    MenuName: "hostelCheckoutHistory",
    Url: "/hostelCheckoutHistory"
  },
  menu_log_viewer: {
    MenuCode: "menu_log_viewer",
    MenuName: "logViewer",
    Url: "/logViewer"
  },
  menu_hostel_application_record: {
    MenuCode: "menu_hostel_application_record",
    MenuName: "studentApplicationHistory",
    Url: "/studentApplicationHistory"
  }
};
